import React from 'react';
import styled from 'styled-components';
import { TInteractiveVote, TVoteRating, TVotesRatingAnswers } from '../../../../store/interactive/types';
import { Button } from '../../../../test/components/ui';

interface Props {
  type: 'pass' | 'review';
  vote: TInteractiveVote | TVoteRating;
  disabled?: boolean;
  sendValue?: (value: number) => void;
}

export const Polls: React.FC<Props> = ({ vote, type, disabled, sendValue }) => {
  const [value, setValue] = React.useState(0);
  const [answer, setAnswer] = React.useState('');

  const checkValue = (answer: TVotesRatingAnswers) => {
    if (type === 'pass') {
      return answer.id === value ? 'tda__active-itm' : '';
    }
    if (type === 'review') {
      return `tda__right-itm__${!!answer.isCorrect}`;
    }
    return '';
  };

  React.useEffect(() => {
    if (type === 'review') {
      const voteRating = vote as unknown as TVoteRating;
      const answer = voteRating.questions.find((item) => item.isCorrect === 1);
      setAnswer(answer?.name || '');
    }
  }, [vote, type]);

  return (
    <div style={{ width: '100%', padding: '20px 50px' }}>
      <div className="tda__wrapper" style={{ width: '100%' }}>
        <div className="tda__testQWrapper" style={{ width: '100%' }}>
          <h5>{vote.title}</h5>
          {answer ? (
            <RightAnswerS>
              Правильна відповідь інтерактиву:
              <span>{answer}</span>
            </RightAnswerS>
          ) : null}
          <ul>
            {vote.questions.map((question) => (
              <li className={checkValue(question as TVotesRatingAnswers)} key={question.id} onClick={() => setValue(question.id)}>
                {question.name}
              </li>
            ))}
          </ul>
          {type === 'pass' && sendValue && (
            <div style={{ textAlign: 'center' }}>
              <Button disabled={disabled} onClick={() => sendValue(value)} title="Відповісти" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const RightAnswerS = styled.div`
  border: 2px solid green;
  color: green;
  padding: 10px;
  margin: 0 0 20px;

  & > * {
    &:nth-child(1) {
      margin-left: 10px;
    }
  }
`;
